export const localeList = [
    // {label: 'English', value: 'en_US'},
    {label: 'Polski', value: 'pl_PL'},
    // {label: 'Українська', value: 'uk_UA'},
];
